import {createContext, use} from 'react'

export const AppPayloadContext = createContext<unknown>(undefined)

export function useAppPayload<T>(): T {
  const appPayload = use(AppPayloadContext)

  return appPayload as T
}
